import { POSTING_ACCOUNT_TYPE } from 'lib/constants';
import { PostingAccountType } from 'lib/types/postingAccounts';

interface Props {
  postingAccountId: number;
  type: PostingAccountType;
  updatePostingAccount: (id: number, type: PostingAccountType) => void;
}

export function OwnerManagerSelect({ postingAccountId, type, updatePostingAccount }: Props) {
  return (
    <select
      className="text-xs p-2 w-22 rounded-lg outline-none border"
      value={type}
      onChange={(e) => updatePostingAccount(
        postingAccountId,
        e.target.value as PostingAccountType,
      )}
    >
      <option value={POSTING_ACCOUNT_TYPE.owner}>Personal</option>
      <option value={POSTING_ACCOUNT_TYPE.manager}>Managed</option>
    </select>
  );
}
